import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/form/input';

interface ISettingsTextboxProps {
  name: string;
  label: string;
  control: any;
  defaultValue: string | number | undefined;
}

export const SettingsTextbox: React.FC<ISettingsTextboxProps> = ({
  name,
  label,
  control,
  defaultValue,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 text-sm">
      <label className="text-gray-500 w-24">{t(label)}</label>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={{
          required: { message: 'Invalid input', value: true },
          min: { message: 'Value must be equal or greater than 0', value: 0 },
        }}
        render={({ field: { onChange, value, name }, fieldState: { error } }) => (
          <div className="flex flex-col">
            <Input
              min={0}
              name={name}
              type="number"
              value={value}
              className="text-center w-36"
              onChange={(value) => onChange(value)}
            />
            <span className="text-red-light w-36">{error?.message}</span>
          </div>
        )}
      />
    </div>
  );
};
